import DetailStatusKaryawan from './DetailStatusKaryawan'

export default DetailStatusKaryawan